import { InfoIcon } from "lucide-react";
import { FC } from "react";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

type Props = {
  hasUniqueContent: boolean;
};

export const ContentEmptyAlert: FC<Props> = ({ hasUniqueContent }) => {
  if (hasUniqueContent) {
    return (
      <Alert className="mb-6">
        <InfoIcon />
        <AlertTitle className="text-base">Add Content</AlertTitle>
        <AlertDescription>
          A CSV has been uploaded to Advanced. You may now add Content to this
          tab.
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <Alert variant="destructive" className="mb-6 ">
      <InfoIcon />
      <AlertTitle className="text-base">Go to Advanced</AlertTitle>
      <AlertDescription>
        Upload a CSV to Advanced to start mapping unique content to this tab.
      </AlertDescription>
    </Alert>
  );
};
